import { RootState } from 'lib/centralStore';
import { useSelector } from 'react-redux';
import { isTruthy } from 'utility/functions';

/** @deprecated in favore di useInternalSession **/
export const useIsAuthenticated = () => useSelector(({ auth }: RootState) => isTruthy(auth?.isLogged));
